import { memoizeWeakValue } from './memoize';

export type SearchParams = Readonly<Record<string, string>>;

export const parseSearchParams = memoizeWeakValue(
  (search: string): SearchParams => {
    return Object.freeze(Object.fromEntries(new URLSearchParams(search)));
  },
);
